import Drawer from '@mui/material/Drawer'
import { Link } from 'react-router-dom'
import styled, { keyframes } from 'styled-components'

export const ADCContainer = styled.div`
  width: 100%;
  background: #fff;
  font-family: Outfit;
  margin: 50px 0;
`

export const ADCTitle = styled.div`
  font-size: 1rem;
  text-align: center;
  display: ${(props) => (props?.hideOnLarge ? 'block' : 'none')};
  @media (min-width: 768px) {
    text-align: left;
    font-size: 1.5rem;
    display: ${(props) => (props?.hideOnLarge ? 'none' : 'block')};
  }
`

export const ADCImagesAndDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (min-width: 768px) {
    flex-direction: row;
    gap: 20px;
  }
`

export const ADCImagesContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
  padding: 50px 0;
  @media (min-width: 768px) {
    justify-content: right;
  }
`

export const ADCImageOne = styled.img`
  border-radius: 16px;
  width: 128px;
  height: 277px;
  position: relative;
  top: 10px;
  z-index: 1;
  left: 15px;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px;
  @media (min-width: 1080px) {
    width: 248px;
    height: 536px;
    left: 25px;
  }
`

export const ADCImageTwo = styled.img`
  border-radius: 16px;
  width: 128px;
  height: 277px;
  position: relative;
  bottom: 10px;
  z-index: 2;
  right: 15px;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px;
  @media (min-width: 1080px) {
    width: 248px;
    height: 536px;
    right: 25px;
  }
`

export const ADCSubtext = styled.div`
  text-align: center;
  margin-bottom: 10px;
  @media (min-width: 768px) {
    text-align: left;
  }
`

export const ADCStoreButtonsContainer = styled.div`
  display: flex;
  gap: 10px;
  height: 30px;
  justify-content: center;
  @media (min-width: 768px) {
    height: 45px;
    justify-content: left;
  }
`

///////////

export const FCOVOContainer = styled.div`
  width: 100%;
  font-family: Outfit;
  display: flex;
  flex-direction: column;
  padding: 64px 24px;
  gap: 10px;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  @media (min-width: 768px) {
    gap: 15px;
    flex-direction: row;
  }
`

export const FCOVOItemContainerPortrait = styled(Link).withConfig({
  shouldForwardProp: (prop) => prop !== 'hoverEffects',
})`
  border-radius: 24px;
  position: relative;
  transition: all 0.2s ease-in-out;
  overflow: hidden;
  width: 275px;
  aspect-ratio: 0.7;
  bottom: 0;
  &:hover {
    bottom: ${(props) => (props?.hoverEffects ? '5px' : '0')};
  }
`

export const FCOVOItemContainerLandscape = styled(Link).withConfig({
  shouldForwardProp: (prop) => prop !== 'hoverEffects',
})`
  overflow: hidden;
  position: relative;
  transition: all 0.2s ease-in-out;
  border-radius: 24px;
  width: 100%;
  max-width: 400px;
  aspect-ratio: 4;
  bottom: 0;
  &:hover {
    bottom: ${(props) => (props?.hoverEffects ? '3px' : '0')};
  }
`

export const FCOVOItemContainerImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: brightness(0.9);
`

export const FCOVOItemContainerText = styled.div`
  position: absolute;
  padding: 20px;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  color: #fff;
  font-weight: 600;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  line-height: 1.1;
  white-space: pre;
  @media (min-width: 1080px) {
    font-size: 20px;
  }
`

////////////////

export const CWBVOContainer = styled.div`
  width: 100%;
  font-family: Outfit;
  padding: 64px 24px;
  background: ${(props) => (props?.backgroundColor ? props?.backgroundColor : '#FFF')};
  display: flex;
  position: relative;
  overflow: hidden;
  @media (min-width: 768px) {
    gap: 24px;
  }
  @media (min-width: 1080px) {
    padding: 64px;
  }
  @media (min-width: 1280px) {
    padding: 64px 90px;
  }
`

export const CWBVODetailsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (min-width: 768px) {
    align-items: unset;
    justify-content: center;
  }
`

export const CWBVOCarouselContainer = styled.div`
  width: 100%;
  @media (max-width: 767px) {
    display: none;
  }
`

export const HeadingAndDescriptionContainerTypeOneCWBVO = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  max-width: 325px;
  margin-bottom: 24px;
  @media (min-width: 768px) {
    max-width: 525px;
  }
`

export const HeadingTypeOneCWBVO = styled.h2`
  font-weight: 500;
  font-size: 1.1rem;
  line-height: 1.3;
  text-align: center;
  margin: 0;
  color: ${(props) => props?.textColor || '#000'};
  @media (min-width: 768px) {
    text-align: left;
    font-size: 2.2rem;
  }
`

export const DescriptionTypeOneCWBVO = styled.p`
  font-weight: 400;
  font-size: 0.8rem;
  text-align: center;
  line-height: 1.3;
  margin: 0;
  color: ${(props) => props?.textColor || '#000'};
  @media (min-width: 768px) {
    text-align: left;
    font-size: 1.3rem;
  }
`

export const ActionButtonTypeOneCWBVO = styled(Link).withConfig({
  shouldForwardProp: (prop) => prop !== 'hoverBackground' && prop !== 'hoverColor',
})`
  flex-grow: 0;
  border: 1.5px solid #000;
  color: #000;
  border-radius: 50px;
  ${(props) => props?.color && `border-color: ${props?.color}`};
  ${(props) => props?.color && `color: ${props?.color}`};
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  padding: 12px 16px;
  font-size: 1rem;
  margin: 24px auto 0;
  @media (min-width: 768px) {
    margin: 24px auto 0 0;
    padding: 16px 24px;
    font-size: 1.1rem;
  }
  &:hover {
    ${(props) => props?.hoverBackground && `background: ${props?.hoverBackground}`};
    ${(props) => props?.hoverColor && `color: ${props?.hoverColor}`};
  }
  &:active {
    ${(props) => props?.hoverBackground && `background: ${props?.hoverBackground}`};
    ${(props) => props?.hoverColor && `color: ${props?.hoverColor}`};
  }
`

export const CWBVOStackCarouselContainer = styled.div`
  width: 220px;
  height: ${(props) => (props?.heightProp ? `${props?.heightProp}px` : '480px')};
  position: relative;
`

export const CWBVOStackCarouselGradient = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: ${(props) => props?.gradientColor};
`

export const CWBVOStackCarouselItemContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  right: 0;
  border-radius: 16px;
  overflow: hidden;
  opacity: ${(props) => (props?.notVisible ? 0 : 1)};
  transform: translateX(${(props) => props?.translateXValue}px);
  transition: all 0.3s ease-in-out;
  ${(props) => props?.noTranslateValue && 'transform: none;'};
`

export const CWBVOStackCarouselArrowsContainer = styled.div`
  width: 100%;
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: center;
  gap: 16px;
`

//////

export const DarkOnHoverContainer = styled.div`
  ${(props) => props?.round && 'border-radius: 50%;'};
  height: fit-content;
  padding: 3px;
  &:hover {
    background: rgba(205, 205, 207, 0.4);
  }
`

export const PublicListingStyledFilterDrawer = styled(Drawer)`
  display: flex;
  justify-content: center;
  // backdrop-filter: blur(1px);
  background-color: rgba(106, 109, 210, 0.2);
  .MuiPaper-root {
    padding: 30px 15px;
    height: 100vh;
    width: 100%;
    background: #efedeb;
    background-size: 100% 100%;
    border-radius: 0px;
    overflow: hidden;
    // overflow-y: auto; /* Hide scrollbar for Chrome, Safari and Opera */
    ::-webkit-scrollbar {
      display: none;
    }
  }
  @media (min-width: 980px) {
    .MuiPaper-root {
      width: 30%;
    }
  }
`

export const NoScrollbarContainer = styled.div`
  /* Hide scrollbar for Chrome, Safari and Opera */
  ::-webkit-scrollbar {
    display: none;
  }
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`

///////
const testimonialKfRTL = keyframes`

0% {
  transform: translateX(0);
}
100% {
  transform: translateX(-100%);
}
`

const testimonialKfLTR = keyframes`{
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(0);
  }
`

export const TestimonialSectionContainer = styled.div`
  background-color: #a8a8a8;
  padding: 2px;
  overflow: hidden;
`

export const TestimonialContainer = styled.div`
  text-align: center;
  display: flex;
  flex-direction: row;
  gap: 20px;
  animation: ${(props) => (props?.direction === 'LTR' ? testimonialKfLTR : testimonialKfRTL)} 20s
    linear infinite;
`

export const TestimonialItemContainer = styled.div`
  background-color: #f9f9f9;
  border-radius: 30px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin: 10px;
  padding: 40px;
  min-width: 600px;
  height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;

  .profile-pic {
    position: absolute;
    top: 20px;
    left: 30px;
    max-width: 50px;
    border-radius: 50%;
    max-height: 50px;
  }

  .name-handle-quote {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex-grow: 1;
    padding: 0 20px;
  }

  .name {
    font-weight: bold;
    margin: 0px 0;
  }

  .handle {
    margin: 0;
    font-style: italic;
    margin: 0px 0;
  }

  .logo {
    display: flex;
    flex-direction: row;
    justify-content: right;
    margin: 0px 0;
  }

  .quote {
    text-align: left;
    margin: 0px 0;
    font-size: 21px;
    margin-left: 10px;
  }

  .quote-logo {
    display: flex;
  }

  img {
    max-width: 90px;
    border-radius: 50%;
    max-height: 80px;
    margin: 10px 0;
    padding: 10px;
    display: flex;
    justify-content: left;
  }
`
